export enum FarmTypeEnum {
    OWN = 'OWN',
    LEASE = 'LEASE',
}
